import type { ParentComponent } from "solid-js";
import type { ListItemHtmlProps } from "../../../types/Menu";
import { isNil } from "lodash-es";

type ListItemContainerProps = {
  type: "column" | "row";
  htmlProps: ListItemHtmlProps | null;
  hidden?: boolean;
  disabled?: boolean;
};

const ListItemContainer: ParentComponent<ListItemContainerProps> = (props) => (
  <div
    class="group flex min-w-0 gap-x-1.5 rounded-sm bg-surface-default px-3 py-2.5 select-none"
    classList={{
      "items-center": props.type === "row",
      "flex-col": props.type === "column",
      "-outline-offset-2 hover:bg-surface-hover focus-visible:outline-default": props.disabled !== true,
      "group-aria-selected:bg-surface-active-brand aria-selected:bg-surface-active-brand selected:bg-surface-active-brand highlighted:bg-surface-hover":
        !isNil(props.htmlProps) && props.disabled !== true,
      "group-aria-selected:bg-surface-active-brand group-highlighted:bg-surface-hover":
        isNil(props.htmlProps) && props.disabled !== true,
      hidden: props.hidden,
    }}
    aria-hidden={props.hidden}
    data-disabled={props.disabled === true ? "" : undefined}
    {...props.htmlProps}
  >
    {props.children}
  </div>
);

export default ListItemContainer;
